export default {
  header: {
    review_us: 'Avalie-nos no Google',
    upload: 'Enviar Avaliação Google',
    not_now: 'Agora não',
  },
  steps: {
    how_it_works: 'Como funciona',
    step_1: {
      title: 'Passo',
      description: 'Escreva uma avaliação sobre {{name}} no Google',
    },
    step_2: {
      title: 'Passo',
      description: 'Envie uma captura de ecrã da sua avaliação publicada (veja o exemplo abaixo)',
    },
  },
  buttons: {
    upload_screenshot: 'Enviar Captura de Ecrã',
    leave_google_review: 'Deixar Avaliação no Google',
    submit_screenshot: 'Submeter Captura de Ecrã',
    return: 'Voltar',
  },
  enter_name: {
    title: 'Nome publicado com a sua avaliação Google',
    place_holder: 'Introduza o nome',
  },
  screenshot_uploaded: {
    title: 'Captura de ecrã enviada',
    description: 'Deslize para baixo para ver a captura completa',
  },
  loading: {
    processing: 'A sua avaliação publicada está a ser analisada',
  },
  error_messages: {
    upload_failed: 'Falha ao enviar captura de ecrã. Por favor, tente novamente.',
    review_already_uploaded:
      'Parece que já enviou uma captura de ecrã de uma avaliação Google. Só pode ser recompensado uma vez por avaliação Google 😊',
    name_missing: {
      description:
        'Por favor, introduza o nome publicado com a sua avaliação Google para nos ajudar a identificar as suas informações.',
      button: {
        title: 'Ok',
      },
    },
  },
};
